import { defineComponent } from 'vue';
export default defineComponent({
    name: 'RoomSpiderwebEdit',
    props: {
        config: {
            type: Object,
            required: true
        }
    }
});
